import React, { createContext, useContext, useState } from "react";
import Checkout from "../pages/Checkout";
import CustomModal from "../components/CustomModal";
import { useAuth } from "./userContext";
import CheckoutModal from "../components/CheckoutModal";

const CheckoutContext = createContext();

export const CheckoutProvider = ({ children }) => {
  const { auth } = useAuth();
  const [checkoutModal, setCheckoutModal] = useState(false);
  //   useEffect(() => {
  //     const params = new URLSearchParams(window.location.search);
  //     if (params.get("checkout") === "true") {
  //       setCheckoutModal(true);
  //     }
  //   }, []);

  return (
    <CheckoutContext.Provider value={{ checkoutModal, setCheckoutModal }}>
      {children}
      {checkoutModal && (
        <CheckoutModal
          show={checkoutModal}
          setShow={setCheckoutModal}
          padding="0"
          width="100%"
          maxWidth={!auth?.user?._id && window?.innerWidth > 992 ? "70%" : ""}
          className="modal_scroll"
        >
          <Checkout />
        </CheckoutModal>
      )}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => useContext(CheckoutContext);
